import * as React from 'react';
import { PdsIconLightbulb as PdsIconLightbulbElement } from '@principal/design-system-icons-web';
import {
  IconSize,
  ValidIconColor,
} from '../../../utils/icon-utilities';
import { createPdsReactComponent } from '../../../../../react/src/lib/create-pds-react-component';

interface IconProps {
  size?: IconSize;
  color?: ValidIconColor;
}

export const PdsIconLightbulb = createPdsReactComponent<IconProps>()({
  tagName: 'pds-icon-lightbulb',
  elementClass: PdsIconLightbulbElement,
  react: React,
});
